import { ComponentsOverrides, Theme } from "@mui/material";

const MuiSelect: ComponentsOverrides<Theme>["MuiSelect"] = {
  select: {},
};

export default MuiSelect;
